import { render } from "./ProblemasAlCargar.vue?vue&type=template&id=7bfa1884"
import script from "./ProblemasAlCargar.vue?vue&type=script&lang=js"
export * from "./ProblemasAlCargar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__